module.exports = __webpack_public_path__ + "static/media/0005.73057c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/handles/H48103/Decors_colored/C07_black/0005.png
// module id = 926
// module chunks = 0